<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>标签关联类型</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>标签关联类型</h1>
      <div class="content_wrap">
        <div class="check_box">
          <p>标签关联类型</p>
          <el-checkbox-group
            v-model="labelType"
            direction="horizontal"
            @change="changeLabelType"
          >
            <el-checkbox label="068b731f32634ce6b92e7a3131268001"
              >全局</el-checkbox
            >
            <el-checkbox label="068b731f32634ce6b92e7a3131268002"
              >关联一级分类标签</el-checkbox
            >
            <el-checkbox label="068b731f32634ce6b92e7a3131268003"
              >关联二级分类标签</el-checkbox
            >
            <el-checkbox label="068b731f32634ce6b92e7a3131268004"
              >关联三级分类标签</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="check_box">
          <p>选择关联分类标签详情</p>
          <el-checkbox-group v-model="check1" direction="horizontal">
            <el-checkbox
              v-for="item in leavelOne"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group>
          <el-checkbox-group v-model="check2" direction="horizontal">
            <el-checkbox
              v-for="item in leavelTwo"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group>
          <el-checkbox-group v-model="check3" direction="horizontal">
            <el-checkbox
              v-for="item in leavelThree"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group>
          <el-checkbox-group v-model="check4" direction="horizontal">
            <el-checkbox
              v-for="item in leavelFour"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>

      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  getKeywordLabel,
} from "../../../api/api";
export default {
  name: "cLabel",
  data() {
    return {
      radio: "",
      isShowStyle: false,
      scrollTop: 0,

      leavellist: [],
      labelType: [],

      leavelOne: [],
      leavelTwo: [],
      leavelThree: [],
      leavelFour: [],

      check1: [],
      check2: [],
      check3: [],
      check4: [],

      loading: false,
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        labels: "",
        labels2: "",
        labels3: "",
        labels4: "",
      },
    };
  },
  watch: {
    labelType(item1, item2) {
      let filter = item2.filter(function (v) {
        return item1.indexOf(v) == -1;
      });
      if (filter.length == 0) return;
      if (filter[0] == "068b731f32634ce6b92e7a3131268001") {
        this.check1 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268002") {
        this.check2 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268003") {
        this.check3 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268004") {
        this.check4 = [];
      }
    },
  },
  created() {
    this.getLabel();
  },
  methods: {
    getLabel() {
      getKeywordLabel().then((res) => {
        this.leavellist = res;
        // 全局：068b731f32634ce6b92e7a3131268001
        // 一级分类：068b731f32634ce6b92e7a3131268002
        // 二级分类：068b731f32634ce6b92e7a3131268003
        // 三级分类：068b731f32634ce6b92e7a3131268004
        // this.leavelOne = res.filter(
        //   (v) => v.levelnum == "068b731f32634ce6b92e7a3131268001"
        // );
        // this.leavelTwo = res.filter(
        //   (v) => v.levelnum == "068b731f32634ce6b92e7a3131268002"
        // );
        // this.leavelThree = res.filter(
        //   (v) => v.levelnum == "068b731f32634ce6b92e7a3131268003"
        // );
        // this.leavelFour = res.filter(
        //   (v) => v.levelnum == "068b731f32634ce6b92e7a3131268004"
        // );
        this.getDetail();
      });
    },
    getDetail() {
      this.loading = true;
      let { id } = this.$route.params;
      getCommidityDetail({ id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.labels = res.labels ? res.labels : "";
        this.formData.labels2 = res.labels2 ? res.labels2 : "";
        this.formData.labels3 = res.labels3 ? res.labels3 : "";
        this.formData.labels4 = res.labels4 ? res.labels4 : "";

        let value1 = res.labels ? res.labels.split(",") : [];
        if (value1.length != 0) {
          this.labelType.push("068b731f32634ce6b92e7a3131268001");
        }
        this.check1 = value1;

        let value2 = res.labels2 ? res.labels2.split(",") : [];
        if (value2.length != 0) {
          this.labelType.push("068b731f32634ce6b92e7a3131268002");
        }
        this.check2 = value2;

        let value3 = res.labels3 ? res.labels3.split(",") : [];
        if (value3.length != 0) {
          this.labelType.push("068b731f32634ce6b92e7a3131268003");
        }
        this.check3 = value3;

        let value4 = res.labels4 ? res.labels4.split(",") : [];
        if (value4.length != 0) {
          this.labelType.push("068b731f32634ce6b92e7a3131268004");
        }
        this.check4 = value4;
        this.changeLabelType(this.labelType);
        this.loading = false;
      });
    },

    // 触发分类标签
    changeLabelType(e) {
      let { leavellist } = this;
      this.leavelOne = [];
      this.leavelTwo = [];
      this.leavelThree = [];
      this.leavelFour = [];

      leavellist.filter((item) => {
        if (item.levelnum == "068b731f32634ce6b92e7a3131268001") {
          e.some((ele) => {
            if (ele === item.levelnum) {
              this.leavelOne.push(item);
            }
          });
        }
        if (item.levelnum == "068b731f32634ce6b92e7a3131268002") {
          e.some((ele) => {
            if (ele === item.levelnum) {
              this.leavelTwo.push(item);
            }
          });
        }
        if (item.levelnum == "068b731f32634ce6b92e7a3131268003") {
          e.some((ele) => {
            if (ele === item.levelnum) {
              this.leavelThree.push(item);
            }
          });
        }
        if (item.levelnum == "068b731f32634ce6b92e7a3131268004") {
          e.some((ele) => {
            if (ele === item.levelnum) {
              this.leavelFour.push(item);
            }
          });
        }
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    handleNavBar(id) {
      if (id == 1) {
        window.location.replace("default.html");
      } else {
        this.$message.warning("即将开放");
      }
    },
    handleReturn() {
      history.back();
    },

    query() {
      let { formData, check1, check2, check3, check4 } = this;
      if (
        check1.length == 0 &&
        check2.length == 0 &&
        check3.length == 0 &&
        check4.length == 0
      ) {
        this.$message.warning("请选择关键标签");
        return;
      }
      this.loading = true;
      formData.labels = check1.join(",");
      formData.labels2 = check2.join(",");
      formData.labels3 = check3.join(",");
      formData.labels4 = check4.join(",");
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          // let message = this.$message.success(data.message);
          // setTimeout(() => {
          //   this.loading = false;
          //   message.close();
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      align-items: flex-start;
      p {
        margin-bottom: 8px;
        font-size: 16px;
        color: #6e6e6e;
      }
      .check_box {
        margin-bottom: 30px;
        /deep/ .el-checkbox {
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>